module.exports = __webpack_public_path__ + "img/from_toeicTest_content02.e5a0291c.svg";